import QRCode from 'qrcode';
import { degrees, PDFDocument, StandardFonts } from 'pdf-lib';



  

// Function to generate QR code image buffer
const generateQRCode = async (data) =>{
    try {
        // Generate QR code as a buffer
        const qrImage = await QRCode.toDataURL(data, { margin: 0 });
        console.error("qrImage in generateQRCode",qrImage);
        return qrImage;
      } catch (err) {
        console.error("err in catch block",err);
      } finally {
        console.error("qrImage finally");
      }
}

// Draws the QR code image and the three labels onto a single page
function drawQrAndLabels(page, embeddedImage, request, layout) {
    const { qrPosition, qrDimensions, qrMarginBottom, fontSize, font } = layout;

    page.drawImage(embeddedImage, {
        ...qrPosition,
        ...qrDimensions,
    });

    const label1 = String(request.label1 ?? '');
    const label2 = String(request.label2 ?? '');
    const label3 = String(request.label3 ?? '');

    page.drawText(label1, {
        x: qrPosition.x + (qrDimensions.width - font.widthOfTextAtSize(label1, fontSize)) / 2,
        y: qrPosition.y - qrMarginBottom - fontSize,
        size: fontSize,
        font,
    });
    page.drawText(label2, {
        x: qrPosition.x + (qrDimensions.width - font.widthOfTextAtSize(label2, fontSize)) / 2,
        y: qrPosition.y - qrMarginBottom - (2 * fontSize),
        size: fontSize,
        font,
    });
    page.drawText(label3, {
        x: qrPosition.x + (qrDimensions.width - font.widthOfTextAtSize(label3, fontSize)) / 2,
        y: qrPosition.y - qrMarginBottom - (3 * fontSize),
        size: fontSize,
        font,
    });
}

// Produces the requested number of copies of a page for a single request, returns how many were added
async function addRequestCopies(newPDFDoc, request, settings, embeddedImage, layout) {
    let added = 0;

    for (let j = 0; j < request.copies; j++) {
        const [page] = await newPDFDoc.copyPages(settings.templatePDF, [0]);
        console.log("Page is", [page]);

        if (!page) {
            console.error(`Error while copying template PDF for size ${request.pageSize}, orientation ${request.orientation} and linguistic regime ${request.linguisticRegime}.`);
            break; // Skip this request and move to the next one
        }

        drawQrAndLabels(page, embeddedImage, request, layout);

        // Rotate page if orientation = landscape
        if (request.orientation === 'Landscape') {
            page.setRotation(degrees(90));
        }

        newPDFDoc.addPage(page);
        added += 1;
    }

    return added;
}

export async function generateRequestsPDF(requests, settingsAndTemplates) {
    const newPDFDoc = await PDFDocument.create();
    const font = await newPDFDoc.embedFont(StandardFonts.Helvetica);
    let addedPages = 0;
    console.log("settingsAndTemplates", settingsAndTemplates);

    // Loop through each request and process them individually
    for (const request of requests) {
        console.log("request", request);
        const settings = settingsAndTemplates[request.pageSize]?.[request.orientation]?.[request.linguisticRegime];
        console.log("settings in generateRequestPDF", settings);

        if (!settings?.templatePDF) {
            console.error(`No template PDF found for size ${request.pageSize}, orientation ${request.orientation} and linguistic regime ${request.linguisticRegime}.`);
            continue; // Skip this request and move to the next one
        }

        const qrPosition = settings?.qrPosition ?? { x: 0, y: 0 };
        const qrDimensions = settings?.qrDimensions ?? { width: 90, height: 90 };
        const qrMarginBottom = settings?.qrMarginBottom ?? 6;
        const pageSize = request.pageSize
        const fontSize =  pageSize === 'A7' ? 8 : 6;
        const layout = { qrPosition, qrDimensions, qrMarginBottom, fontSize, font };

        try {
            console.log("request.url", request.url);
            const qrImage = await generateQRCode(request.url);
            console.log("qrImage generated", qrImage);

            const imageBytes = await fetch(qrImage).then((res) => res.arrayBuffer());
            const embeddedImage = await newPDFDoc.embedPng(imageBytes); // Use embedJpg for JPEG images

            console.log("request settings.templatePDF ", request);
            addedPages += await addRequestCopies(newPDFDoc, request, settings, embeddedImage, layout);

        } catch (err) {
            console.error("Error processing request", request, err);
            // Continue to next request if there's an error
            continue;
        }
    }

    if (addedPages === 0) {
        console.warn('No pages generated for this request group. Skipping empty PDF output.');
        return null;
    }

    // Save the generated PDF document
    return newPDFDoc.save();
}
